// // Copyright Open Trade Technology Ltd. 2023. All rights reserved.
export const WILD_CAT_ABI = [
  { inputs: [], name: 'AccountBlocked', type: 'error' },
  { inputs: [], name: 'AnnualInterestBipsTooHigh', type: 'error' },
  { inputs: [], name: 'AprChangeOnClosedMarket', type: 'error' },
  { inputs: [], name: 'BadLaunchCode', type: 'error' },
  { inputs: [], name: 'BadRescueAsset', type: 'error' },
  { inputs: [], name: 'BorrowAmountTooHigh', type: 'error' },
  { inputs: [], name: 'BorrowFromClosedMarket', type: 'error' },
  { inputs: [], name: 'BorrowWhileSanctioned', type: 'error' },
  { inputs: [], name: 'BuyBackOnDelinquentMarket', type: 'error' },
  { inputs: [], name: 'CapacityChangeOnClosedMarket', type: 'error' },
  { inputs: [], name: 'CloseMarketWithUnpaidWithdrawals', type: 'error' },
  { inputs: [], name: 'DepositToClosedMarket', type: 'error' },
  { inputs: [], name: 'FIFOQueueOutOfBounds', type: 'error' },
  { inputs: [], name: 'InsufficientReservesForFeeWithdrawal', type: 'error' },
  { inputs: [], name: 'InsufficientReservesForNewLiquidityRatio', type: 'error' },
  { inputs: [], name: 'InsufficientReservesForOldLiquidityRatio', type: 'error' },
  { inputs: [], name: 'InvalidArrayLength', type: 'error' },
  { inputs: [], name: 'MarketAlreadyClosed', type: 'error' },
  { inputs: [], name: 'MaxSupplyExceeded', type: 'error' },
  { inputs: [], name: 'NoReentrantCalls', type: 'error' },
  { inputs: [], name: 'NotApprovedBorrower', type: 'error' },
  { inputs: [], name: 'NotApprovedLender', type: 'error' },
  { inputs: [], name: 'NotFactory', type: 'error' },
  { inputs: [], name: 'NullBurnAmount', type: 'error' },
  { inputs: [], name: 'NullBuyBackAmount', type: 'error' },
  { inputs: [], name: 'NullFeeAmount', type: 'error' },
  { inputs: [], name: 'NullMintAmount', type: 'error' },
  { inputs: [], name: 'NullRepayAmount', type: 'error' },
  { inputs: [], name: 'NullTransferAmount', type: 'error' },
  { inputs: [], name: 'NullWithdrawalAmount', type: 'error' },
  { inputs: [], name: 'ProtocolFeeChangeOnClosedMarket', type: 'error' },
  { inputs: [], name: 'ProtocolFeeTooHigh', type: 'error' },
  { inputs: [], name: 'RepayToClosedMarket', type: 'error' },
  { inputs: [], name: 'ReserveRatioBipsTooHigh', type: 'error' },
  { inputs: [], name: 'SphereXOperatorRequired', type: 'error' },
  { inputs: [], name: 'WithdrawalBatchNotExpired', type: 'error' },
  {
    anonymous: false,
    inputs: [{ indexed: true, internalType: 'address', name: 'account', type: 'address' }],
    name: 'AccountSanctioned',
    type: 'event',
  },
  {
    anonymous: false,
    inputs: [{ indexed: false, internalType: 'uint256', name: 'annualInterestBipsUpdated', type: 'uint256' }],
    name: 'AnnualInterestBipsUpdated',
    type: 'event',
  },
  {
    anonymous: false,
    inputs: [
      { indexed: true, internalType: 'address', name: 'owner', type: 'address' },
      { indexed: true, internalType: 'address', name: 'spender', type: 'address' },
      { indexed: false, internalType: 'uint256', name: 'value', type: 'uint256' },
    ],
    name: 'Approval',
    type: 'event',
  },
  {
    anonymous: false,
    inputs: [{ indexed: false, internalType: 'uint256', name: 'assetAmount', type: 'uint256' }],
    name: 'Borrow',
    type: 'event',
  },
  {
    anonymous: false,
    inputs: [
      { indexed: false, internalType: 'address', name: 'oldEngineAddress', type: 'address' },
      { indexed: false, internalType: 'address', name: 'newEngineAddress', type: 'address' },
    ],
    name: 'ChangedSpherexEngineAddress',
    type: 'event',
  },
  {
    anonymous: false,
    inputs: [
      { indexed: false, internalType: 'address', name: 'oldSphereXAdmin', type: 'address' },
      { indexed: false, internalType: 'address', name: 'newSphereXAdmin', type: 'address' },
    ],
    name: 'ChangedSpherexOperator',
    type: 'event',
  },
  {
    anonymous: false,
    inputs: [
      { indexed: true, internalType: 'address', name: 'from', type: 'address' },
      { indexed: false, internalType: 'uint256', name: 'assetAmount', type: 'uint256' },
    ],
    name: 'DebtRepaid',
    type: 'event',
  },
  {
    anonymous: false,
    inputs: [
      { indexed: true, internalType: 'address', name: 'account', type: 'address' },
      { indexed: false, internalType: 'uint256', name: 'assetAmount', type: 'uint256' },
      { indexed: false, internalType: 'uint256', name: 'scaledAmount', type: 'uint256' },
    ],
    name: 'Deposit',
    type: 'event',
  },
  {
    anonymous: false,
    inputs: [{ indexed: false, internalType: 'uint256', name: 'assets', type: 'uint256' }],
    name: 'FeesCollected',
    type: 'event',
  },
  {
    anonymous: false,
    inputs: [
      { indexed: false, internalType: 'uint256', name: 'fromTimestamp', type: 'uint256' },
      { indexed: false, internalType: 'uint256', name: 'toTimestamp', type: 'uint256' },
      { indexed: false, internalType: 'uint256', name: 'scaleFactor', type: 'uint256' },
      { indexed: false, internalType: 'uint256', name: 'baseInterestRay', type: 'uint256' },
      { indexed: false, internalType: 'uint256', name: 'delinquencyFeeRay', type: 'uint256' },
      { indexed: false, internalType: 'uint256', name: 'protocolFees', type: 'uint256' },
    ],
    name: 'InterestAndFeesAccrued',
    type: 'event',
  },
  {
    anonymous: false,
    inputs: [{ indexed: false, internalType: 'uint256', name: 'timestamp', type: 'uint256' }],
    name: 'MarketClosed',
    type: 'event',
  },
  {
    anonymous: false,
    inputs: [{ indexed: false, internalType: 'uint256', name: 'assets', type: 'uint256' }],
    name: 'MaxTotalSupplyUpdated',
    type: 'event',
  },
  {
    anonymous: false,
    inputs: [{ indexed: false, internalType: 'uint256', name: 'protocolFeeBips', type: 'uint256' }],
    name: 'ProtocolFeeBipsUpdated',
    type: 'event',
  },
  {
    anonymous: false,
    inputs: [{ indexed: false, internalType: 'uint256', name: 'reserveRatioBipsUpdated', type: 'uint256' }],
    name: 'ReserveRatioBipsUpdated',
    type: 'event',
  },
  {
    anonymous: false,
    inputs: [
      { indexed: true, internalType: 'address', name: 'account', type: 'address' },
      { indexed: false, internalType: 'uint256', name: 'expiry', type: 'uint256' },
      { indexed: false, internalType: 'uint256', name: 'scaledAmount', type: 'uint256' },
      { indexed: false, internalType: 'uint256', name: 'normalizedAmount', type: 'uint256' },
    ],
    name: 'SanctionedAccountAssetsQueuedForWithdrawal',
    type: 'event',
  },
  {
    anonymous: false,
    inputs: [
      { indexed: true, internalType: 'address', name: 'account', type: 'address' },
      { indexed: false, internalType: 'address', name: 'escrow', type: 'address' },
      { indexed: false, internalType: 'uint256', name: 'amount', type: 'uint256' },
    ],
    name: 'SanctionedAccountAssetsSentToEscrow',
    type: 'event',
  },
  {
    anonymous: false,
    inputs: [
      { indexed: true, internalType: 'address', name: 'account', type: 'address' },
      { indexed: false, internalType: 'address', name: 'escrow', type: 'address' },
      { indexed: false, internalType: 'uint32', name: 'expiry', type: 'uint32' },
      { indexed: false, internalType: 'uint256', name: 'amount', type: 'uint256' },
    ],
    name: 'SanctionedAccountWithdrawalSentToEscrow',
    type: 'event',
  },
  {
    anonymous: false,
    inputs: [
      { indexed: false, internalType: 'uint256', name: 'scaleFactor', type: 'uint256' },
      { indexed: false, internalType: 'bool', name: 'isDelinquent', type: 'bool' },
    ],
    name: 'StateUpdated',
    type: 'event',
  },
  {
    anonymous: false,
    inputs: [
      { indexed: true, internalType: 'address', name: 'from', type: 'address' },
      { indexed: true, internalType: 'address', name: 'to', type: 'address' },
      { indexed: false, internalType: 'uint256', name: 'value', type: 'uint256' },
    ],
    name: 'Transfer',
    type: 'event',
  },
  {
    anonymous: false,
    inputs: [{ indexed: true, internalType: 'uint256', name: 'expiry', type: 'uint256' }],
    name: 'WithdrawalBatchClosed',
    type: 'event',
  },
  {
    anonymous: false,
    inputs: [{ indexed: true, internalType: 'uint256', name: 'expiry', type: 'uint256' }],
    name: 'WithdrawalBatchCreated',
    type: 'event',
  },
  {
    anonymous: false,
    inputs: [
      { indexed: true, internalType: 'uint256', name: 'expiry', type: 'uint256' },
      { indexed: false, internalType: 'uint256', name: 'scaledTotalAmount', type: 'uint256' },
      { indexed: false, internalType: 'uint256', name: 'scaledAmountBurned', type: 'uint256' },
      { indexed: false, internalType: 'uint256', name: 'normalizedAmountPaid', type: 'uint256' },
    ],
    name: 'WithdrawalBatchExpired',
    type: 'event',
  },
  {
    anonymous: false,
    inputs: [
      { indexed: true, internalType: 'uint256', name: 'expiry', type: 'uint256' },
      { indexed: false, internalType: 'uint256', name: 'scaledAmountBurned', type: 'uint256' },
      { indexed: false, internalType: 'uint256', name: 'normalizedAmountPaid', type: 'uint256' },
    ],
    name: 'WithdrawalBatchPayment',
    type: 'event',
  },
  {
    anonymous: false,
    inputs: [
      { indexed: true, internalType: 'uint256', name: 'expiry', type: 'uint256' },
      { indexed: true, internalType: 'address', name: 'account', type: 'address' },
      { indexed: false, internalType: 'uint256', name: 'normalizedAmount', type: 'uint256' },
    ],
    name: 'WithdrawalExecuted',
    type: 'event',
  },
  {
    anonymous: false,
    inputs: [
      { indexed: true, internalType: 'uint256', name: 'expiry', type: 'uint256' },
      { indexed: true, internalType: 'address', name: 'account', type: 'address' },
      { indexed: false, internalType: 'uint256', name: 'scaledAmount', type: 'uint256' },
      { indexed: false, internalType: 'uint256', name: 'normalizedAmount', type: 'uint256' },
    ],
    name: 'WithdrawalQueued',
    type: 'event',
  },
  {
    inputs: [],
    name: 'accruedProtocolFees',
    outputs: [{ internalType: 'uint256', name: '', type: 'uint256' }],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [
      { internalType: 'address', name: '', type: 'address' },
      { internalType: 'address', name: '', type: 'address' },
    ],
    name: 'allowance',
    outputs: [{ internalType: 'uint256', name: '', type: 'uint256' }],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [],
    name: 'annualInterestBips',
    outputs: [{ internalType: 'uint256', name: '', type: 'uint256' }],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [
      { internalType: 'address', name: 'spender', type: 'address' },
      { internalType: 'uint256', name: 'amount', type: 'uint256' },
    ],
    name: 'approve',
    outputs: [{ internalType: 'bool', name: '', type: 'bool' }],
    stateMutability: 'nonpayable',
    type: 'function',
  },
  {
    inputs: [],
    name: 'archController',
    outputs: [{ internalType: 'address', name: '', type: 'address' }],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [],
    name: 'asset',
    outputs: [{ internalType: 'address', name: '', type: 'address' }],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [{ internalType: 'address', name: 'account', type: 'address' }],
    name: 'balanceOf',
    outputs: [{ internalType: 'uint256', name: '', type: 'uint256' }],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [{ internalType: 'uint256', name: 'amount', type: 'uint256' }],
    name: 'borrow',
    outputs: [],
    stateMutability: 'nonpayable',
    type: 'function',
  },
  {
    inputs: [],
    name: 'borrowableAssets',
    outputs: [{ internalType: 'uint256', name: '', type: 'uint256' }],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [],
    name: 'borrower',
    outputs: [{ internalType: 'address', name: '', type: 'address' }],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [{ internalType: 'address', name: 'newSphereXEngine', type: 'address' }],
    name: 'changeSphereXEngine',
    outputs: [],
    stateMutability: 'nonpayable',
    type: 'function',
  },
  { inputs: [], name: 'closeMarket', outputs: [], stateMutability: 'nonpayable', type: 'function' },
  { inputs: [], name: 'collectFees', outputs: [], stateMutability: 'nonpayable', type: 'function' },
  {
    inputs: [],
    name: 'coverageLiquidity',
    outputs: [{ internalType: 'uint256', name: '', type: 'uint256' }],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [],
    name: 'currentState',
    outputs: [
      {
        components: [
          { internalType: 'bool', name: 'isClosed', type: 'bool' },
          { internalType: 'uint128', name: 'maxTotalSupply', type: 'uint128' },
          { internalType: 'uint128', name: 'accruedProtocolFees', type: 'uint128' },
          { internalType: 'uint128', name: 'normalizedUnclaimedWithdrawals', type: 'uint128' },
          { internalType: 'uint104', name: 'scaledTotalSupply', type: 'uint104' },
          { internalType: 'uint104', name: 'scaledPendingWithdrawals', type: 'uint104' },
          { internalType: 'uint32', name: 'pendingWithdrawalExpiry', type: 'uint32' },
          { internalType: 'bool', name: 'isDelinquent', type: 'bool' },
          { internalType: 'uint32', name: 'timeDelinquent', type: 'uint32' },
          { internalType: 'uint16', name: 'protocolFeeBips', type: 'uint16' },
          { internalType: 'uint16', name: 'annualInterestBips', type: 'uint16' },
          { internalType: 'uint16', name: 'reserveRatioBips', type: 'uint16' },
          { internalType: 'uint112', name: 'scaleFactor', type: 'uint112' },
          { internalType: 'uint32', name: 'lastInterestAccruedTimestamp', type: 'uint32' },
        ],
        internalType: 'struct MarketState',
        name: 'state',
        type: 'tuple',
      },
    ],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [],
    name: 'decimals',
    outputs: [{ internalType: 'uint8', name: '', type: 'uint8' }],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [],
    name: 'delinquencyFeeBips',
    outputs: [{ internalType: 'uint256', name: '', type: 'uint256' }],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [],
    name: 'delinquencyGracePeriod',
    outputs: [{ internalType: 'uint256', name: '', type: 'uint256' }],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [{ internalType: 'uint256', name: 'amount', type: 'uint256' }],
    name: 'deposit',
    outputs: [],
    stateMutability: 'nonpayable',
    type: 'function',
  },
  {
    inputs: [{ internalType: 'uint256', name: 'amount', type: 'uint256' }],
    name: 'depositUpTo',
    outputs: [{ internalType: 'uint256', name: '', type: 'uint256' }],
    stateMutability: 'nonpayable',
    type: 'function',
  },
  {
    inputs: [
      { internalType: 'address', name: 'accountAddress', type: 'address' },
      { internalType: 'uint32', name: 'expiry', type: 'uint32' },
    ],
    name: 'executeWithdrawal',
    outputs: [{ internalType: 'uint256', name: '', type: 'uint256' }],
    stateMutability: 'nonpayable',
    type: 'function',
  },
  {
    inputs: [
      { internalType: 'address[]', name: 'accountAddresses', type: 'address[]' },
      { internalType: 'uint32[]', name: 'expiries', type: 'uint32[]' },
    ],
    name: 'executeWithdrawals',
    outputs: [{ internalType: 'uint256[]', name: 'amounts', type: 'uint256[]' }],
    stateMutability: 'nonpayable',
    type: 'function',
  },
  {
    inputs: [],
    name: 'factory',
    outputs: [{ internalType: 'address', name: '', type: 'address' }],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [],
    name: 'feeRecipient',
    outputs: [{ internalType: 'address', name: '', type: 'address' }],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [
      { internalType: 'address', name: 'accountAddress', type: 'address' },
      { internalType: 'uint32', name: 'expiry', type: 'uint32' },
    ],
    name: 'getAccountWithdrawalStatus',
    outputs: [
      {
        components: [
          { internalType: 'uint104', name: 'scaledAmount', type: 'uint104' },
          { internalType: 'uint128', name: 'normalizedAmountWithdrawn', type: 'uint128' },
        ],
        internalType: 'struct AccountWithdrawalStatus',
        name: 'status',
        type: 'tuple',
      },
    ],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [
      { internalType: 'address', name: 'accountAddress', type: 'address' },
      { internalType: 'uint32', name: 'expiry', type: 'uint32' },
    ],
    name: 'getAvailableWithdrawalAmount',
    outputs: [{ internalType: 'uint256', name: '', type: 'uint256' }],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [],
    name: 'getUnpaidBatchExpiries',
    outputs: [{ internalType: 'uint32[]', name: '', type: 'uint32[]' }],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [{ internalType: 'uint32', name: 'expiry', type: 'uint32' }],
    name: 'getWithdrawalBatch',
    outputs: [
      {
        components: [
          { internalType: 'uint104', name: 'scaledTotalAmount', type: 'uint104' },
          { internalType: 'uint104', name: 'scaledAmountBurned', type: 'uint104' },
          { internalType: 'uint128', name: 'normalizedAmountPaid', type: 'uint128' },
        ],
        internalType: 'struct WithdrawalBatch',
        name: 'batch',
        type: 'tuple',
      },
    ],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [],
    name: 'hooks',
    outputs: [{ internalType: 'HooksConfig', name: '', type: 'uint256' }],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [],
    name: 'isClosed',
    outputs: [{ internalType: 'bool', name: '', type: 'bool' }],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [],
    name: 'maxTotalSupply',
    outputs: [{ internalType: 'uint256', name: '', type: 'uint256' }],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [],
    name: 'maximumDeposit',
    outputs: [{ internalType: 'uint256', name: '', type: 'uint256' }],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [],
    name: 'name',
    outputs: [{ internalType: 'string', name: '', type: 'string' }],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [{ internalType: 'address', name: 'accountAddress', type: 'address' }],
    name: 'nukeFromOrbit',
    outputs: [],
    stateMutability: 'nonpayable',
    type: 'function',
  },
  {
    inputs: [],
    name: 'previousState',
    outputs: [
      {
        components: [
          { internalType: 'bool', name: 'isClosed', type: 'bool' },
          { internalType: 'uint128', name: 'maxTotalSupply', type: 'uint128' },
          { internalType: 'uint128', name: 'accruedProtocolFees', type: 'uint128' },
          { internalType: 'uint128', name: 'normalizedUnclaimedWithdrawals', type: 'uint128' },
          { internalType: 'uint104', name: 'scaledTotalSupply', type: 'uint104' },
          { internalType: 'uint104', name: 'scaledPendingWithdrawals', type: 'uint104' },
          { internalType: 'uint32', name: 'pendingWithdrawalExpiry', type: 'uint32' },
          { internalType: 'bool', name: 'isDelinquent', type: 'bool' },
          { internalType: 'uint32', name: 'timeDelinquent', type: 'uint32' },
          { internalType: 'uint16', name: 'protocolFeeBips', type: 'uint16' },
          { internalType: 'uint16', name: 'annualInterestBips', type: 'uint16' },
          { internalType: 'uint16', name: 'reserveRatioBips', type: 'uint16' },
          { internalType: 'uint112', name: 'scaleFactor', type: 'uint112' },
          { internalType: 'uint32', name: 'lastInterestAccruedTimestamp', type: 'uint32' },
        ],
        internalType: 'struct MarketState',
        name: '',
        type: 'tuple',
      },
    ],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [],
    name: 'queueFullWithdrawal',
    outputs: [{ internalType: 'uint32', name: 'expiry', type: 'uint32' }],
    stateMutability: 'nonpayable',
    type: 'function',
  },
  {
    inputs: [{ internalType: 'uint256', name: 'amount', type: 'uint256' }],
    name: 'queueWithdrawal',
    outputs: [{ internalType: 'uint32', name: 'expiry', type: 'uint32' }],
    stateMutability: 'nonpayable',
    type: 'function',
  },
  {
    inputs: [{ internalType: 'uint256', name: 'amount', type: 'uint256' }],
    name: 'repay',
    outputs: [],
    stateMutability: 'nonpayable',
    type: 'function',
  },
  {
    inputs: [
      { internalType: 'uint256', name: 'repayAmount', type: 'uint256' },
      { internalType: 'uint256', name: 'maxBatches', type: 'uint256' },
    ],
    name: 'repayAndProcessUnpaidWithdrawalBatches',
    outputs: [],
    stateMutability: 'nonpayable',
    type: 'function',
  },
  {
    inputs: [{ internalType: 'address', name: 'token', type: 'address' }],
    name: 'rescueTokens',
    outputs: [],
    stateMutability: 'nonpayable',
    type: 'function',
  },
  {
    inputs: [],
    name: 'reserveRatioBips',
    outputs: [{ internalType: 'uint256', name: '', type: 'uint256' }],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [],
    name: 'scaleFactor',
    outputs: [{ internalType: 'uint256', name: '', type: 'uint256' }],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [{ internalType: 'address', name: 'account', type: 'address' }],
    name: 'scaledBalanceOf',
    outputs: [{ internalType: 'uint256', name: '', type: 'uint256' }],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [],
    name: 'scaledTotalSupply',
    outputs: [{ internalType: 'uint256', name: '', type: 'uint256' }],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [],
    name: 'sentinel',
    outputs: [{ internalType: 'address', name: '', type: 'address' }],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [
      { internalType: 'uint16', name: '_annualInterestBips', type: 'uint16' },
      { internalType: 'uint16', name: '_reserveRatioBips', type: 'uint16' },
    ],
    name: 'setAnnualInterestAndReserveRatioBips',
    outputs: [],
    stateMutability: 'nonpayable',
    type: 'function',
  },
  {
    inputs: [{ internalType: 'uint256', name: '_maxTotalSupply', type: 'uint256' }],
    name: 'setMaxTotalSupply',
    outputs: [],
    stateMutability: 'nonpayable',
    type: 'function',
  },
  {
    inputs: [{ internalType: 'uint16', name: '_protocolFeeBips', type: 'uint16' }],
    name: 'setProtocolFeeBips',
    outputs: [],
    stateMutability: 'nonpayable',
    type: 'function',
  },
  {
    inputs: [],
    name: 'sphereXEngine',
    outputs: [{ internalType: 'address', name: '', type: 'address' }],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [],
    name: 'sphereXOperator',
    outputs: [{ internalType: 'address', name: '', type: 'address' }],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [],
    name: 'symbol',
    outputs: [{ internalType: 'string', name: '', type: 'string' }],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [],
    name: 'totalAssets',
    outputs: [{ internalType: 'uint256', name: '', type: 'uint256' }],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [],
    name: 'totalDebts',
    outputs: [{ internalType: 'uint256', name: '', type: 'uint256' }],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [],
    name: 'totalSupply',
    outputs: [{ internalType: 'uint256', name: '', type: 'uint256' }],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [
      { internalType: 'address', name: 'to', type: 'address' },
      { internalType: 'uint256', name: 'amount', type: 'uint256' },
    ],
    name: 'transfer',
    outputs: [{ internalType: 'bool', name: '', type: 'bool' }],
    stateMutability: 'nonpayable',
    type: 'function',
  },
  {
    inputs: [
      { internalType: 'address', name: 'from', type: 'address' },
      { internalType: 'address', name: 'to', type: 'address' },
      { internalType: 'uint256', name: 'amount', type: 'uint256' },
    ],
    name: 'transferFrom',
    outputs: [{ internalType: 'bool', name: '', type: 'bool' }],
    stateMutability: 'nonpayable',
    type: 'function',
  },
  { inputs: [], name: 'updateState', outputs: [], stateMutability: 'nonpayable', type: 'function' },
  {
    inputs: [],
    name: 'version',
    outputs: [{ internalType: 'string', name: '', type: 'string' }],
    stateMutability: 'pure',
    type: 'function',
  },
  {
    inputs: [],
    name: 'withdrawableProtocolFees',
    outputs: [{ internalType: 'uint128', name: '', type: 'uint128' }],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [],
    name: 'withdrawalBatchDuration',
    outputs: [{ internalType: 'uint256', name: '', type: 'uint256' }],
    stateMutability: 'view',
    type: 'function',
  },
]
